export const alarmStatus = {
  normal: 'normal',
  warning: 'warning',
  danger: 'danger',
  fail: 'fail',
};
